import { parse as parseQueryString } from 'querystring';

export default location => {
  if (location && location.search) {
    const webviewParam = parseQueryString((location.search || '').substr(1)).webview ? 'webview=1&' : '';
    return `/login?${webviewParam}returnTo=${encodeURIComponent(location.pathname + location.search)}`;
  }

  return `/login${location ? location.pathname : ''}`;
};
